import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const emailColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'emailAddress1',
  headerName: 'Email Address',
  initialHide: true,
};
